<div id="analytics-container" *loading="loadStatus">
    <div class="session-log-header" *ngIf="!programsMode">
        <div class="session-log-header-left">
            <button mat-button (click)="goBack()" class="session-log-header-button">
                <mat-icon>arrow_back</mat-icon>
                <span>BACK</span>
            </button>
            <div *ngIf="userName && sessionDate" class="session-title">
                <span class="session-title-name">{{ userName }}</span>&nbsp;on&nbsp;<span> {{ sessionDate | date:'longDate' }}</span>
            </div>
        </div>

        <button mat-button class="session-log-header-button" (click)="exportStats()">
            <mat-icon svgIcon="download"></mat-icon>
            <span>Export</span>
        </button>
    </div>
  <table #table mat-table matSort (matSortChange)="sortData($event)" *ngIf="dataSource" [dataSource]="dataSource">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let log"> {{log.date | date:'medium' }} </td>
      </ng-container>
      <ng-container matColumnDef="object">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let log"> {{ programsMode ? log.sender : log.activity }} </td>
      </ng-container>
      <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let log"> {{ getType(log.verb) }} </td>
      </ng-container>
      <ng-container matColumnDef="verb">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let log"> {{ formatVerb(log.verb) }} </td>
      </ng-container>
      
      <ng-container matColumnDef="result">
          <th mat-header-cell *matHeaderCellDef> {{ programsMode ? 'Message' : 'Result' }} </th>
          <td mat-cell *matCellDef="let log" class="result-cell"> <pre>{{  formatResult(log.result) }}</pre> </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div *ngIf="noData" class="nodata"> No data available </div>
</div>

